import React, { useEffect, useState } from "react";
import BreadcrumbsHeader from "./breadcrumbs/BreadcrumbsHeader";
import Brands1 from "./brands/Brands1";
import { FaArrowRight, FaArrowLeft, FaPlay } from "react-icons/fa";
import Slider from "react-slick";
import "aos/dist/aos.css";
import AOS from "aos";
  const seoFeatures = [
  {
    icon: "/images/seo-icon.png",
    title: "Leading name in the SEO Industry",
    description:
      "We are the best SEO Companies in India. Our awards and honours put us amongst the top SEO companies in India.",
    animation: "fade-left",
  },
  {
    icon: "/images/best-proposal-icon.png",
    title: "Best professionals in the Industry",
    description:
      "Our SEO services are provided by the SEO certified experts which helps us in providing consistent best services to our clients.",
    animation: "fade-down",
  },
  {
    icon: "/images/industry-exp-icon.png",
    title: "Industry Expertise",
    description:
      "With our experience we achieved acumen in various industries – Home & Building, Education & Training, Auto, Ecommerce, Healthcare, and Travel.",
    animation: "fade-right",
  },
  {
    icon: "/images/seo-practice-icon.png",
    title: "Proven SEO Practices",
    description:
      "With our competent team of professionals our SEO practices are at check with our on-page SEO techniques and link building tricks.",
    animation: "fade-left",
  },
  {
    icon: "/images/seo-reporting-icon.png",
    title: "Transparent Account Management and SEO Reporting",
    description:
      "We believe a company works on trust hence our work is transparent with continuous updates which you can access anytime.",
    animation: "fade-up",
  },
  {
    icon: "/images/value-added-icon.png",
    title: "Value Added Services",
    description:
      "Combining our Search Engine Optimization services with other digital marketing services result in unmatchable value propositions.",
    animation: "fade-right",
  },
  {
    icon: "/images/ethical-seo-icon.png",
    title: "Ethical SEO",
    description:
      "Our team works solely to help your website reach the top of the SERP’S.",
    animation: "fade-left",
  },
  {
    icon: "/images/seo-outcome-icon.png",
    title: "Incredible outcome",
    description:
      "With the best SEO services we focus on excellent results with happy customers.",
    animation: "fade-right",
  },
];

const faqs = [
  {
    question: "What is SEO in marketing?",
    answer:
      "SEO or ‘search engine optimization’ is a process of optimizing the website’s traffic by expanding its visibility on search engines and improving rankings for unpaid results.",
  },
  {
    question: "Why do I need SEO services?",
    answer:
      "SEO is a proven business tactic that helps in growth and reaching goals. It increases visibility, credibility, and long-term organic results.",
  },
  {
    question: "What are your SEO plans?",
    answer:
      "We offer customized SEO services including initial audit, on-page optimization, content marketing, analytics, and monthly reporting.",
  },
  {
    question: "Are Custom SEO Packages available?",
    answer:
      "Yes, we make customized SEO plans based on your goals and business type. Our experts ensure your objectives are met effectively.",
  },
  {
    question: "Can I change my plan after the Sign Up?",
    answer:
      "Yes, you can switch or upgrade your plan anytime. We ensure smooth transitions and consistent results.",
  },
];

const testimonials = [
  {
    name: "Arpan Ghosh",
    text: "The job which I appointed them was nicely done. The only thing I was concerned about was if they were authentic or not. But everything turned out good and these guys are 100% authentic. Highly recommended by me. I would love to work with these guys in the near future.",
    img: "/images/male-user.png",
  },
  {
    name: "Zeus",
    text: "I took the e-mail marketing service from them. They were highly dedicated towards their work and always kept me updated. After the splendid service they gave me for e-Mail marketing, I asked them for the Search Engine Optimization service as well. It also turned out well and I can actually see a change in my website. The reach of my website seems to be increased and I can also see new audiences checking my website. 5 stars to their work. 😉",
    img: "/images/male-user.png",
  },
  {
    name: "Mr. Badshah",
    text: "I appointed this company for e-mail marketing. To be honest, they did a splendid job. They completely nailed it. I can see the difference in my e-commerce business. If you are looking for a company for the e-mail marketing service, you can choose Digital India Leader blindfolded. 5 stars for there service.",
    img: "/images/male-user.png",
  },
  {
    name: "Sonia Sharma",
    text: "Best in class service. I hired them for a Search Engine Optimization service, they did a splendid job. I can legit see the positive response on my website and can see the reach has been increased in a drastic manner. Cheers to DIL team.",
    img: "/images/female-user.png",
  },
  {
    name: "Jason D. Sealey",
    text: "I hired them for PPC marketing. They provided me with good service. I am happy personalised attitude of dealing. Thanks to these people, my returns has increased and I can finally see a positive response on my website.",
    img: "/images/male-user.png",
  },
];

const SearchEngineOptimization = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

const [openFAQ, setOpenFAQ] = useState(0);
const NextArrow = ({ onClick }) => (
  <div className="custom-arrow next-arrow" onClick={onClick}>
    <FaArrowRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev-arrow" onClick={onClick}>
    <FaArrowLeft />
  </div>
);

  return (
    <div>
      <BreadcrumbsHeader
        title="Search Engine Optimization"
        backgroundImage="/images/breadcrumbs/digital-marketing-cover.jpg"
      />

      {/* Enquiry Section */}
      <section className="section-home-secondary" id="enquire_now">
        <div className="b-home-about relative">
          <div className="vertical-container-top-mod vertical-left home-about-side-title hidden-md">
            <span className="vertical-text-main color-add text-uppercase">ISOLS Group</span>
            <span className="vertical-text-additional color-add-2 text-uppercase">DM</span>
          </div>

          <div className="container">
            <div className="row">
              {/* Left Content */}
              <div className="col-xs-12 col-sm-6">
                <div className="b-mod-heading" data-aos="fade-down">
                  <p className="first-heading font-secondary" style={{ fontSize: 20, fontWeight: 600, marginBottom: 10 }}>
                    Search Engine Optimization Services in India
                  </p>
                  <h2 className="heading-line line-right1 customColor customPseudoElBg">
                    <strong>Best SEO Services! Within Best Prices!</strong>
                  </h2>
                  <p className="second-heading font-additional">
                    With the ever evolving internet with thousands and lakhs of brands, it is quite easy to get lost in it. Our Search Engine Optimization services make sure that it does not happen. It makes sure you stay in the game with your growth reaching heights.
                  </p>
                  <p style={{ lineHeight: 2 }}>
                   ISOLS Group's digital wing is one of the top-rated SEO Company, offering the best SEO services in Delhi, Gurgaon, Noida, across India, and globally in Canada. We have a team of SEO certified experts. We provide SEO services to start-ups & small businesses in India. Client satisfaction is our topmost priority and keeping that in mind we have customized SEO plans for every client. Our team of experts works on individual projects to achieve the finest outcome. Our SEO services are affordable and quite pocket friendly. With our Search Engine Optimization strategies, happy customers, awards, team of professionals we guarantee, you are in safe hands!
                  </p>
                </div>
              </div>

              {/* Right Form */}
              <div className="col-xs-12 col-sm-6" data-aos="fade-left">
                <div className="footer-form" id="contact-form">

                  {/* Flowlu Form */}
                  <script
                    type="text/javascript"
                    dangerouslySetInnerHTML={{
                      __html: `(function (w, d, c) {
                        (w[c] = w[c] || []).push(function(flowluHost) {
                          try {
                            new FlowluForm.init({
                              id: 101591,
                              token: 'a1b962d0c1fb87354b47c32c88929ea2',
                              host: flowluHost
                            });
                          } catch(e){}
                        });
                        var n = d.getElementsByTagName("script")[0],
                            s = d.createElement("script"),
                            f = function () { n.parentNode.insertBefore(s, n); };
                        s.type = "text/javascript";
                        s.async = true;
                        s.src = "https://erp.isolsgroup.com/application/classes/Module/Crm/static/js/ext-form.js";
                        if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
                      })(window, document, "flowlu_forms");`,
                    }}
                  />

                  <div className="flowlu-form">
                     <h2 className="footer-form-title" style={{ color: "#000", fontSize: 20 }}>
                    SEEK EXPERT'S ADVICE &amp; GET PROPOSAL
                  </h2>
                    <input type="hidden" name="url" value="/search-engine-optimization" />
                    <input type="hidden" name="pipeline_id" value="14" />
                    <input type="hidden" name="source_id" value="36" />

                    <input type="text" placeholder="Your Name*" className="flowlu-input" required />
                    <input type="text" placeholder="Your Company Name*" className="flowlu-input" required />
                    <input type="email" placeholder="Email Address*" className="flowlu-input" required />
                    <input type="number" placeholder="Mobile Number*" className="flowlu-input" required />
                    <textarea
                      placeholder="Type Your Query"
                      rows="5"
                      className="flowlu-input"
                      style={{ width: "100%", borderRadius: 0 }}
                    ></textarea>

                    <button className="btn btn-default-arrow" style={{ marginTop: 30 }}>
                      <FaArrowRight /> Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What Makes Us the Best */}
      <section className="section-services1" style={{ padding: "51px 0 0px" }}>
        <div className="container">
          <div className="b-mod-heading">
            <h2>
              What Makes Us the Best SEO Service Provider in India?
            </h2>
            <p>Customized, outcome-oriented SEO packages for each business.</p>
            <p>Affordable plans tailored for your goals.</p>
            <p>Consistent top SEO services globally.</p>
            <p>Innovative optimization strategies for all industries.</p>
            <p>Client happiness and satisfaction at our core.</p>
          </div>
        </div>
      </section>

      {/* Engagement Models */}
      <section className="b-home-services" style={{ paddingTop: 0 }}>
        <div className="container">
          <h2
            className="vc_custom_heading text-center"
            style={{ fontSize: 40, color: "#ff9600", fontWeight: 700 }}
          >
            SEO Engagement Models
          </h2>
          <div className="b-services-holder clearfix row">
            {[
              {
                title: "Explore Our Client-Friendly Packages",
                desc: "Want your sales to reach the peak? Choose from our best SEO services.",
              },
              {
                title: "SEO Plans",
                desc: "Affordable and effective SEO plans that fit your business perfectly.",
              },
              {
                title: "SEO Consulting",
                desc: "Expert consulting to help your team plan strategies wisely.",
              },
              {
                title: "Dedicated SEO Resources",
                desc: "Hire dedicated SEO professionals or teams as per your needs.",
              },
              {
                title: "SEO Reseller Services",
                desc: "Partner with one of the top SEO resellers in India.",
              },
              {
                title: "SEO Advisory",
                desc: "Affordable SEO support for small businesses and startups.",
              },
            ].map((item, i) => (
              <div className="col-xs-12 col-sm-4 home" data-aos="fade-up" key={i}>
                <div className="b-services-item" >
                  <div className="services-text">
                    <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                      {item.title}
                    </h6>
                    <p>{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      {/*<div className="b-plans-holder section-about1">
        <div className="container text-center">
          <Link to="#enquire_now" className="btn btn-default-arrow btn-sm">
            <FaArrowRight /> Enquire Now
          </Link>
          <p style={{ fontSize: 17, marginTop: 20 }}>
            <a href="https://www.digitalindialeader.com/" target="_blank" rel="noopener noreferrer">
              <FaArrowRight /> Know more
            </a>{" "}
            about digital marketing services offered by Digital India Leader – A digital marketing wing of ISOLS Group.
          </p>
        </div>
      </div>/* End CTA */}

      {/* Section 1 - Intro */}
      <section className="section-services" style={{ padding: "50px 0 0px" }}>
        <div className="container text-center">
          <h2
            style={{
              fontSize: "40px",
              color: "#ff9600",
              fontFamily: "Raleway",
              fontWeight: "700",
            }}
          >
            Our Search Engine Optimization (SEO) Strategies
          </h2>
          <p className="second-heading font-additional">
            At ISOLS Group, we provide transparent and professional SEO services
            with a clear explanation of how each strategy works. We keep our
            customers informed at every step.
          </p>
        </div>
      </section>

      {/* Section 2 - Video */}
      <section className="section-about" style={{ padding: "0px 0 0" }}>
        <div className="container text-center">
          <div className="b-video-holder" data-aos="fade-left">
            <a
              href="#"
              className="video-image"
              data-toggle="modal"
              data-target="#myModal"
            >
              <FaPlay className="demo-icon play-icon" /><br></br>
              <span className="video-title">Play the Video</span>
            </a>
          </div>
        </div>
      </section>

      {/* Section 3 - Why Choose */}
      <section className="section-why" style={{ padding: "50px 0" }}>
        <div className="container">
          <h2
            className="text-center"
            style={{
              fontSize: "40px",
              color: "#ff9600",
              fontFamily: "Raleway",
              fontWeight: "700",
            }}
          >
            WHY CHOOSE ISOLS GROUP FOR SEARCH ENGINE OPTIMIZATION?
          </h2>
          <p className="text-center">
            ISOLS Group stands out among SEO providers for our customized
            approach and affordable expertise by certified professionals.
          </p>

          <div className="b-services-holder">
            <div className="row">
              {seoFeatures.map((feature, i) => (
                <div
                  key={i}
                  className={`col-md-4 col-sm-6 wow ${feature.animation}`}
                  data-aos={feature.animation}
                >
                  <div className="b-services-item">
                    <div className="services-icon">
                      <img src={feature.icon} alt={feature.title} />
                    </div>
                    <div className="services-text">
                      <h6 className="services-title">{feature.title}</h6>
                      <p>{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

   <section>
    <div className="container" style={{ padding: "60px 0" }}>
  <div className="row">

    {/* LEFT SIDE – FAQ */}
    <div className="col-lg-6 col-md-12">
      <section className="faq-section">
        <h2 className="faq-title">ASK YOUR QUERIES?</h2>
        <p className="faq-subtitle">SEO FAQs</p>

        <div className="faq-box">
          {faqs.map((item, index) => (
            <div
              key={index}
              className={`faq-item ${openFAQ === index ? "active" : ""}`}
              onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
            >
              <div className="faq-question">
                <span className="faq-icon">
                  {openFAQ === index ? "✖" : "➕"}
                </span>
                {item.question}
              </div>

              {openFAQ === index && (
                <div className="faq-answer">{item.answer}</div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>

    {/* RIGHT SIDE – TESTIMONIALS */}
    <div className="col-lg-6 col-md-12">
      <section className="testimonial-section">
  <h2 className="testimonial-title">What our clients say about us</h2>

  <Slider
    dots={true}
    infinite={true}
    speed={500}
    slidesToShow={1}
    slidesToScroll={1}
    autoplay={true}
    autoplaySpeed={3000}
    arrows={true}
    nextArrow={<NextArrow />}
    prevArrow={<PrevArrow />}
  >
    {testimonials.map((item, i) => (
      <div key={i} className="testimonial-card">
        <img src={item.img} alt="" className="testimonial-img" />
        <h4 className="testimonial-name">{item.name}</h4>
        <p className="testimonial-text">{item.text}</p>
      </div>
    ))}
  </Slider>
</section>

    </div>

  </div>
</div>

    </section>


          <section
      className="section-about1 sectionn"
      style={{ paddingBottom: "100px" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <h2
              style={{
                fontSize: "25px",
                color: "#ff9600",
                lineHeight: 1.2,
                textAlign: "center",
                fontFamily: "Raleway",
                fontWeight: 700,
                fontStyle: "normal",
                padding: "0 0 30px 0",
                textTransform: "uppercase",
              }}
              className="vc_custom_heading vc_custom_1490112359046"
            >
              What Our Client Feel About Us
            </h2>

            <div className="row">
              <div className="col-lg-4">
                <iframe
                  width="100%"
                  height="310"
                  src="https://www.youtube.com/embed/ofWi6TePZQo"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Client Feedback 1"
                ></iframe>
              </div>

              <div className="col-lg-4">
                <iframe
                  width="100%"
                  height="310"
                  src="https://www.youtube.com/embed/3iJH9el9dzQ"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Client Feedback 2"
                ></iframe>
              </div>

              <div className="col-lg-4">
                <iframe
                  width="100%"
                  height="310"
                  src="https://www.youtube.com/embed/Hfh01auRGAw"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Client Feedback 3"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

      <Brands1 />
    </div>
  );
};

export default SearchEngineOptimization;
